import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  getHelpFontFamily,
  getHelpFontWeight,
  getKnowledgeCardLinkSx,
  getKnowledgeCardTitleSx,
  HELP_BODY_SX,
  HELP_PAGE_TITLE_SX,
  helpTextRenderingSx,
} from '../constants/help-typography';

export const useHelpTypography = () => {
  const { i18n } = useTranslation();

  return useMemo(() => {
    const { language } = i18n;
    const fontFamily = getHelpFontFamily(language);

    return {
      fontFamily,
      mediumWeight: getHelpFontWeight(language, 500),
      pageTitleSx: {
        ...HELP_PAGE_TITLE_SX,
        ...helpTextRenderingSx,
        fontFamily,
        fontWeight: getHelpFontWeight(language, 600),
      },
      cardTitleSx: getKnowledgeCardTitleSx(language),
      cardLinkSx: getKnowledgeCardLinkSx(language),
      bodySx: {
        ...HELP_BODY_SX,
        ...helpTextRenderingSx,
        fontFamily,
        fontWeight: getHelpFontWeight(language, 400),
      },
    };
  }, [i18n.language]);
};
